import actions from "./tokenManager.actions";
import mutations from "./tokenManager.mutation";
import getters from './tokenManager.getters';
import { defaultSortingParams } from '@/components/SM/SecretManager/sm.secret.types';
import { tokenDefaultData } from '@/components/SM/TokenManager/sm.token.types';

export interface State {
    tokenList: any[],
    isGlobalTokenActive: Boolean,
    prevRoute: String,
    searchTokenName: String,
    allMappedTokensDeleted: Boolean,
    tokenId: String,
    tokenName: String,
    isTokenDeleteActive: Boolean,
    tokenPageNum: Number,
    tokenSortParams: SortingParams,
    isTokenFormOpen: Boolean,
    tokenFormData: Object
}

export interface SortingParams {
  sortBy: String,
  sortByType: String
}

const initialState: State = {
    tokenList: [],
    prevRoute: '',
    isGlobalTokenActive: true,
    searchTokenName: '',
    allMappedTokensDeleted: false,
    tokenId: '',
    tokenName: '',
    isTokenDeleteActive: false,
    tokenPageNum: 1,
    tokenSortParams: {
      ...defaultSortingParams
    },
    isTokenFormOpen: false,
    tokenFormData: tokenDefaultData
}

export default {
  namespaced: true,
  state: initialState,
  actions,
  mutations,
  getters
};
